export default __webpack_public_path__ + "0f6b611e1fbe55b0f55ace6a69bac371.webp";